import RestartAltIcon from '@mui/icons-material/RestartAlt';
import { Button, ButtonProps } from '@mui/material';
import { useFormikContext } from 'formik';
import { useReportCtx } from '../../../report-ctx';

/**
 * Reset report form button (icon only). Same style as list-view RefreshButton (outlined, secondary).
 */
export const ResetReportBtn = ({
  onReset,
  ...rest
}: {
  onReset?: VoidFunction;
} & Partial<ButtonProps>) => {
  const fp = useFormikContext();
  const ctx = useReportCtx();

  return (
    <Button
      size="small"
      variant="outlined"
      color="secondary"
      onClick={() => {
        fp.resetForm(ctx.defaultValues ? { values: ctx.defaultValues } : undefined);
        onReset?.();
      }}
      disabled={!fp.isValid || ctx.isLoading}
      sx={{ padding: 0, minWidth: '44px' }}
      {...rest}
    >
      <RestartAltIcon fontSize="small" />
    </Button>
  );
};
